import { useState } from 'react'

import { Button, Popup, TeslaIntegrationSetupGuide } from '@/components'

type TeslaIntegrationSetupGuideProps = {
    isCompleted: boolean
    onComplete: () => void
}

export const TeslaIntegrationSetupPopup = ({
    isCompleted,
    ...props
}: TeslaIntegrationSetupGuideProps) => {
    const [isOpen, setIsOpen] = useState(false)
    return <>
        <Button
            type="button"
            design={isCompleted ? 'btn-secondary' : 'btn-primary'}
            onClick={() => {
                setIsOpen(true)
                props.onComplete()
            }}
        >
            View Tesla Integration Setup Guide
        </Button>

        <Popup
            open={isOpen}
            onClose={() => setIsOpen(false)}
            className="w-200"
        >
            <TeslaIntegrationSetupGuide
                onComplete={() => {
                    setIsOpen(false)
                }}
                isCompleted={isCompleted}
            />
        </Popup>
    </>
}
